import {
  FETCH_BASIC_REPORT,
  FETCH_DETAILED_REPORT,
  FETCH_ISSUES_REPORT,
  RESET_REPORT
} from "./actions.type";
import { FETCH_REPORT_START, SET_REPORT } from "./mutations.type";
import Vue from "vue";

const state = {
  report: [],
  isLoading: false
};

const getters = {
  report: state => state.report,
  reportIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_BASIC_REPORT]({ commit }, params) {
    commit(FETCH_REPORT_START);
    return Vue.axios
      .get("report/basic", {
        params: params
      })
      .then(({ data }) => {
        commit(SET_REPORT, data);
      });
  },
  [FETCH_DETAILED_REPORT]({ commit }, params) {
    commit(FETCH_REPORT_START);
    return Vue.axios
      .get("report/detailed", {
        params: params
      })
      .then(({ data }) => {
        commit(SET_REPORT, data);
      });
  },
  [FETCH_ISSUES_REPORT]({ commit }, params) {
    commit(FETCH_REPORT_START);
    return Vue.axios
      .get("report/issues", {
        params: params
      })
      .then(({ data }) => {
        commit(SET_REPORT, data);
      });
  },
  [RESET_REPORT](context) {
    context.commit(SET_REPORT, []);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_REPORT_START](state) {
    state.isLoading = true;
  },
  [SET_REPORT](state, data) {
    state.report = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
